module.exports = __webpack_public_path__ + "static/media/minimize.3fdbc2f4.svg";